import React, { useState, useEffect } from "react";
import PlayerWindow from "./PlayerWindow";
import { incrementLike, decrementLike } from "../FirebaseUtils";
import filled from "../../assets/images/filled.png";
import empty from "../../assets/images/outlined.png";
import play_button from "../../assets/images/play_button.png";
import pause_button from "../../assets/images/pause_button.png";

const AudioPlayer = ({ audioSrc, audioPath, onClose }) => {
  const [isLiked, setIsLiked] = useState(false);
  useEffect(() => {
    if (!audioPath) return;

    const likedMusics = JSON.parse(localStorage.getItem("likedMusics") || "[]");
    if (likedMusics.includes(audioPath)) {
      setIsLiked(true);
    } else {
      setIsLiked(false);
    }
  }, [audioPath]);
  const handleToggleLike = async () => {
    if (!audioPath) return;
    const likedMusics = JSON.parse(localStorage.getItem("likedMusics") || "[]");

    if (!isLiked) {
      await incrementLike(audioPath);
      const newArray = [...likedMusics, audioPath];
      localStorage.setItem("likedMusics", JSON.stringify(newArray));

      setIsLiked(true);
    } else {
      await decrementLike(audioPath);

      const newArray = likedMusics.filter((id) => id !== audioPath);
      localStorage.setItem("likedMusics", JSON.stringify(newArray));

      setIsLiked(false);
    }
  };

  return (
    <PlayerWindow title="Audio Player" onClose={onClose}>
      <audio autoPlay controls style={{ width: "100%" }}>
        <source src={audioSrc} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>

      {/* <div style={{ marginTop: 5, marginLeft: 10 }}>
        <button
          onClick={handleToggleLike}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px"
          }}
        >
          <img
            src={isLiked ? filled : empty}
            alt={isLiked ? "Unlike" : "Like"}
            style={{ width: "24px", height: "24px" }}
          />
          <span>{isLiked ? "Unlike" : "Like"}</span>
        </button>
      </div> */}
    </PlayerWindow>
  );
};

export default AudioPlayer;